import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Resetpassword from './pages/Resetpassword';
import Forgetpassword from './pages/Forgetpassword';
import MainLayout from './components/MainLayout';
import Createjob from './pages/AddCategory';
import ViewProfile from './pages/ViewProfile';
import AddProduct from './pages/AddProduct';
import CatsubList from './pages/CatsubList';
import SubCategory from './pages/SubCategory';
import { UserProvider } from './Context/UserContext'; // Assuming you have a UserContext for managing user state
import ProductList from './pages/ProductList';
import SubCategoryList from './pages/SubCategoryList';
import Pincode from './Master/Pincode';
import BrandMaster from './Master/BrandMaster';
import Customer from './Master/Customer';
import CustomerList from './pages/CustomerList';
import TermsMaster from './Master/Terms';
import Vendor from './Master/Vendor';
import VendorList from './pages/VendorList';
import PurchaseOrder from './Transaction/PurchaseOrder';
import SalesOrder from './Transaction/SalesOrder';
import StocksReport from './Reports/StocksReport';
import SalesReport from './Reports/SalesReport';
import PurchaseReport from './Reports/PurchaseReport';
import PromoCode from './pages/PromoCode';
import User from './pages/User';
import Banner from './Master/Banner';
import StoreMaster from './Master/StoreMaster';
import DeliveryBoy from './Master/DeliveryBoy';
import DeliveryBoyList from './pages/DeliveryBoyList';
import Offers from './Master/Offers';
import AddCategory from './pages/AddCategory';
import AssignOrders from './pages/AssignOrders';
import PrivacyPolicy from './Master/PrivacyPolicy';
import ShippingPolicy from './Master/ShippingPolicy';
import Contact from './Master/Contact';
import RefundPolicy from './Master/RefundPolicy';



function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/reset-password' element={<Resetpassword />} />
          <Route path='/forget-password' element={<Forgetpassword />} />
          <Route path="/admin" element={<MainLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="view-profile" element={<ViewProfile />} />
            <Route path='add-category' element={<AddCategory/> }/>
            <Route path='add-product' element={<AddProduct/>}/>
            <Route path='product-list' element={<ProductList/>}/>
            {/* <Route path='addCategory' element={<CatsubList/>}/> */}
            <Route path='add-sub-cat' element={<SubCategory/>}/>
            <Route path='sub-list' element={<SubCategoryList/>}/>
            <Route path='user' element={<User/>}/>

            {/* MASTERS */}
            <Route path='pincode' element={<Pincode/>}/>
            <Route path='brand' element={<BrandMaster/>}/>
            <Route path='customer' element={<Customer/>}/>
            <Route path='vendor' element={<Vendor/>}/>
            {/* <Route path='ven-list' element={<VendorList/>}/> */}
            {/* <Route path='cus-list' element={<CustomerList/>}/> */}
            <Route path='terms' element={<TermsMaster/>}/>
            <Route path='privacyPolicy' element={<PrivacyPolicy/>} />
            <Route path='shippingPolicy' element={<ShippingPolicy/>} />
            <Route path='refundPolicy' element={<RefundPolicy/>} />
            <Route path='contact' element={<Contact/>} />
            <Route path='banner' element={<Banner/>}/>
            <Route path='store' element={<StoreMaster/>}/>
            <Route path='offers' element={<Offers/>} />

             {/* Transaction */}
            <Route path='purchase' element={<PurchaseOrder/>}/>
            <Route path='sales' element={<SalesOrder/>}/>

            {/* Reports */}
            <Route path='stock-report' element={<StocksReport/>}/>
            <Route path='sale-report' element={<SalesReport/>}/>
            <Route path='purchase-report' element={<PurchaseReport/>}/>

            {/* promocode */}
            <Route path='promo' element={<PromoCode/>}/>

              {/* Delivery */}
              <Route path='deliveryBoy' element={<DeliveryBoy/>}/>
              <Route path='del-list' element={<DeliveryBoyList/>}/>
              <Route path='assignOrders' element={<AssignOrders/>} />
          </Route> 
        </Routes>
      </Router>
    </UserProvider>
  );
}
export default App;